<!--
 * @Author: your name
 * @Date: 2021-04-14 15:15:42
 * @LastEditTime: 2021-05-07 14:25:23
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \topboomadmin\src\views\auction\List.vue
-->
<template>
  <div class="content">
    <el-form inline
             :model="search"
             class="tb-form">
      <el-form-item label="商品名称">
        <el-input placeholder="请输入"
                  v-model="search.name"></el-input>
      </el-form-item>
      <el-form-item label="活动时间">
        <el-date-picker type="daterange"
                        value-format="yyyy-MM-dd"
                        format="yyyy-MM-dd"
                        :clearable="true"
                        range-separator="至"
                        start-placeholder="开始日期"
                        end-placeholder="结束日期"
                        v-model="search.date"></el-date-picker>
      </el-form-item>
      <el-form-item label="状态">
        <el-select v-model="search.status">
          <el-option label="所有"
                     :value="-1"></el-option>
          <el-option label="无效"
                     :value="0"></el-option>
          <el-option label="有效"
                     :value="1"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button type="primary"
                   @click="getList">搜索</el-button>
        <el-button type="primary"
                   @click="onReset">重置</el-button>
      </el-form-item>
    </el-form>
    <div class="add">
      <el-button class="tb-button"
                 type="primary"
                 @click="add">
        <i class="tb-icon-plus" />新增拍卖商品
      </el-button>
    </div>
    <div class="tablebox">
      <el-table :data="list"
                class="tb-table">
        <el-table-column label="商品名称"
                         prop="productName"
                         show-overflow-tooltip>
        </el-table-column>
        <el-table-column label="原价">
          <template slot-scope="scope">
            {{scope.row.marketPrice | formatPrice}}
          </template>
        </el-table-column>
        <el-table-column label="起拍价"
                         prop="auction_limit">
          <template slot-scope="scope">
            {{scope.row.auctionLimit | formatPrice}}
          </template>
        </el-table-column>
        <el-table-column prop="prop"
                         label="加价幅度">
          <template slot-scope="scope">
            {{scope.row.auction_step | formatPrice}}
          </template>
        </el-table-column>
        <el-table-column prop="prop"
                         label="保证金">
          <template slot-scope="scope">
            {{scope.row.auction_deposit | formatPrice}}
          </template>
        </el-table-column>
        <el-table-column prop="prop"
                         label="活动时间"
                         show-overflow-tooltip>
          <template slot-scope="scope">
            {{scope.row.start_time + '-' + scope.row.end_time}}
          </template>
        </el-table-column>
        <el-table-column prop="prop"
                         label="成交价">
          <template slot-scope="scope">
            {{scope.row.max_amount*1/100}}
          </template>
        </el-table-column>
        <el-table-column prop="prop"
                         label="状态">
          <template slot-scope="scope">
            {{scope.row.status === 0 ? '无效' : '有效'}}
          </template>
        </el-table-column>
        <el-table-column prop="prop"
                         label="操作">
          <template slot-scope="scope">
            <span class="edit"
                  @click="toDetail(scope.row)">查看</span>
            <el-divider direction="vertical"></el-divider>
            <span class="edit"
                  @click="deleteAuction(scope.row)">删除</span>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination background
                     class="tb-pagination"
                     @size-change="sizeChange"
                     layout="prev, pager, next, sizes"
                     :current-page="page.no + 1"
                     :page-sizes="[10,20,50,100]"
                     :page-size="page.size"
                     :total="page.total"
                     @current-change="pageChange" />
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      list: [],
      search: {
        name: '',
        date: ["", ""],
        status: -1
      },
      page: {
        no: 0,
        size: 10,
        total: 0
      }
    }
  },
  mounted () {
    this.getList()
  },
  filters: {
    formatPrice (price) {
      console.log(price)
      return (price / 100).toFixed(2)
    }
  },
  methods: {
    add () {
      this.toDetail(null)
    },
    toDetail (row) {
      if (null === row) {
        this.$router.push('/auction/detail')
      } else {
        this.$router.push('/auction/detail?id=' + row.auction_id)
      }

    },
    deleteAuction (row) {
      this.$confirm('您确定要删除该拍卖商品吗？', '', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        const params = {
          id: row.auction_id,
          status: -1
        }
        const url = 'admin/auction/edit'
        this.$https.post(url, params).then(res => {
          if (res) {
            this.$message.success('编辑成功')
            this.getList()
          }
        })
      }).catch(() => { })
    },
    onReset () {
      this.search = { name: '', status: -1, date: ["", ""] }
      this.page.no = 0
      this.getList()
    },
    getList () {
      let params = { page_no: this.page.no, page_size: this.page.size }
      params = Object.assign(params, this.search)
      if (params.date.length > 0 && params.date[0]) {
        params.start_date = params.date[0]
        params.end_date = params.date[1]
      }
      const url = 'admin/auction/list'
      this.$https.get(url, { params }).then((result) => {
        if (result) {
          this.list = result.list
          this.page.total = result.total_count
        }
      })
    },
    pageChange (no) {
      this.page.no = no - 1
      this.getList()
    },
    sizeChange (val) {
      this.page.no = 0
      this.page.size = val
      this.getList()
    }
  }
}
</script>